module.exports = __webpack_public_path__ + "img/pluto161.42eb900d.jpg";